export enum MtSocialProviderType {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
  FIREBASE = 'FIREBASE',
}

export interface MtSocialProvidersData {
  currentType?: MtSocialProviderType;
  linkedTypes: MtSocialProviderType[];
  onClick: (type: MtSocialProviderType) => void;
  loading?: boolean;
}

export interface MtSocialProvidersProps extends MtSocialProvidersData {}
